import React from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';
import PropTypes from 'prop-types';
import spinner from './spinner.gif';

import { Typography } from '../..';

import styles from './label.module.scss';

const Label = ({ loading, message, ...props }) => {
  return (
    <ReactModal
      // eslint-disable-next-line react/prop-types
      className={cn(styles.modal, props.className, { [styles.open]: loading })}
      overlayClassName={styles.overlay}
      isOpen={loading}
      appElement={document.getElementById('root')}
      closeTimeoutMS={300}
    >
      <div className={styles.inner}>
        <img className={styles.image} src={spinner} />
        <Typography textSm mlSm mb0>
          {message}
        </Typography>
      </div>
    </ReactModal>
  );
};

Label.propTypes = {
  /** Whether or not the loader is active */
  loading: PropTypes.bool,
  /** The text to display in the loader */
  message: PropTypes.string,
};

Label.defaultProps = {
  loading: undefined,
  message: undefined,
};

export default Label;
